//@ts-nocheck
import * as React from 'react';
import renderHTML from 'react-render-html';
import { toCurrency } from '../../Common/Helpers';

class CongressionalDistrictTable extends React.Component<Props, {}> {

    render() {
        const { spending_heading, spending_congress, start_year, current_year, spending_congress_total, spending_congress_total_range } = this.props;

        var congressTable = <div className="loading">loading <i className="fa fa-spinner"></i></div>;
        if (spending_congress !== undefined) {
            congressTable =
                spending_congress.sort((a, b) => (a.payment_amt_range < b.payment_amt_range) ? 1 : -1).map(function (table, index) {
                    const repName = "Rep. " + table.rep_name;
                    if (table.rep_name == "" || table.rep_name == null || table.rep_name == "Vacant") {
                        repName = "Vacant";
                    }

                    return (<tr key={index}>
                        <td style={{ "width": "10px" }}><b>{table.district_name}</b></td>
                        <td style={{ "width": "300px" }}>{repName}</td>
                        <td style={{ textAlign: "right", "width": "60px" }}>${toCurrency(table.payment_amt)}</td>
                        <td style={{ textAlign: "right", "width": "150px" }}>${toCurrency(table.payment_amt_range)}</td>
                    </tr>);
                })
        };
        if (spending_congress?.length > 0 && spending_heading !== undefined)

            return (
                <div className="row">
                    <div className="col-md-12">
                        <h3>{renderHTML(spending_heading)}</h3>
                        <table className="table">
                            <thead><tr><th style={{ "width": "300px" }} colSpan={2}>District</th>
                                <th style={{ "width": "80px", "textAlign": "right" }}>{current_year}</th>
                                <th style={{ "width": "80px", "textAlign": "right" }}>{`${start_year}-${current_year}`}</th>
                            </tr></thead>
                            <tbody>
                                {congressTable}
                                <tr><td style={{ "width": "300px" }} colSpan={2}><b>Total In-State Spending</b></td>
                                    <td style={{ "width": "80px", "textAlign": "right" }}><b>${toCurrency(spending_congress_total)}</b></td>
                                    <td style={{ "width": "80px", "textAlign": "right" }}><b>${toCurrency(spending_congress_total_range)}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        return (<div></div>)

    }
}

export default CongressionalDistrictTable;